import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';

import EventDetails from 'components/UI/Event/EventDetails';

const EventDetailsStyled = withStyles(theme => ({
  root: {
    color: '#262326'
  },
  left: {
    '& .MuiTypography-h4': {
      color: '#262326'
    },
    '& .MuiTypography-body1': {
      color: '#6d676d'
    },
    '& .MuiTypography-caption': {
      color: '#262326'
    }
  },
  itemThumb: {
    backgroundColor: '#f1ddfb',
    '&:before': {
      backgroundImage: 'none',
      backgroundColor: '#f1ddfb',
      backgroundImage: 'url('+require('assets/images/event.png')+')'
    }
  }
}))(EventDetails)

class EventDetailsWrapper extends Component {
  render() {
    return (<EventDetailsStyled templateProps={{kind: 'fullWidth', maxWidth: 'auto'}} {...this.props}/>)
  }
}

export default EventDetailsWrapper;



// WEBPACK FOOTER //
// ./src/components/Event/EventDetails.jsx